var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCentre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "gnav-header-1i89ga9 eac13zx0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-.002 7c-.516 0-.955.331-1.117.792-.04.117-.143.208-.266.208h-1.53a.235.235 0 01-.239-.264 3.184 3.184 0 016.335.447c0 1.33-.923 2.079-1.443 2.502l-.067.054c-.277.225-.445.361-.567.506-.101.12-.106.173-.106.213v.296a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-.296c0-.643.269-1.136.576-1.501.252-.3.573-.558.809-.748l.076-.062c.575-.467.722-.671.722-.964 0-.653-.53-1.183-1.183-1.183zm-.996 6.25a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-1.5z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCentre);
export default __webpack_public_path__ + "static/media/helpCentre.a3d181f83868a534bb3c11d7c5526520.svg";
export { ForwardRef as ReactComponent };